import { Box, Container } from '@mui/material'
import React from 'react'
import VinButton from '../Header/VinButton'
import SubTitle from '../MainComponents/SubTitle'
import { fullCenter } from '../../../base'
import { Txt } from '../../../Routes/Localized'
import { FOOTER_LINE, FOOTER_LINE_COLOR } from './base'

export default function BuyExtension() {
    return (
        <div>
            <Container maxWidth="lg" sx={{ ...fullCenter, flexDirection: 'column', pb: '10px' }}>
                <SubTitle title={<Txt id="23019" />}
                    subtitle={<Txt id="23029" />}
                    sxTitle={{ color: 'white' }}
                    sxSubtitle={{ color: 'white' }}
                    sx={{ pt: '8px', pb: '40px' }}
                />
                <VinButton sx={{ maxWidth: '600px', mb: '16px' }} />
            </Container>

            <Container
                maxWidth="xl"
            >
                <Box sx={{ px: { xs: '0px', sm: '0px', md: '0px', lg: '32px', xl: '32px' }, }}>
                    <Box sx={{ ...FOOTER_LINE, mt: '16px', mb: '32px' }} />
                </Box>
            </Container>
        </div>
    )
}
